import {
  EnergyPro,
  ResourceType,
  SentinelTarget,
  SentinelTargetType,
  Site,
} from '@energybox/react-ui-library/dist/types';
import { Checkbox } from '@energybox/react-ui-library/dist/components';

import React from 'react';
import { fetchEnergyProsBySiteId } from '../../../../actions/legacyFetches';
import ResourcePath from '../../../../containers/ResourcePath';
import styles from './StepRollout.module.css';
import { SensorChip } from './TargetChips';

type Props = {
  site: Site;
  handleTargetSelect: (sentinelTarget: SentinelTarget) => void;
  handleSetResourceRelation: (arg: number, arg2: number[]) => void;
  selected: number[];
};

type State = {
  energyPros: EnergyPro[];
  isLoading: boolean;
};

class StepRolloutEnergyPros extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      energyPros: [],
      isLoading: true,
    };
  }

  componentDidMount(): void {
    let dublicateSentinelkey = localStorage.getItem('duplicateSentinelKey');
    if (dublicateSentinelkey) {
      const { handleTargetSelect } = this.props;
      if (this.props.selected.length > 0) {
        handleTargetSelect({
          targetId: this.props.selected[0],
          targetType: SentinelTargetType.ENERGYPRO,
        });
      }
    }
    this.onLoad();
  }

  onLoad = async () => {
    this.setState({ isLoading: true });
    const { handleSetResourceRelation } = this.props;

    try {
      const { site } = this.props;

      const energyPros = await fetchEnergyProsBySiteId(site.id);

      handleSetResourceRelation(
        site.id,
        energyPros.map((g: EnergyPro) => g.id)
      );

      const sortedEnergyPros = energyPros.sort((a, b) =>
        a.title.localeCompare(b.title)
      );

      this.setState({
        energyPros: sortedEnergyPros,
        isLoading: false,
      });
    } catch (err) {
      this.setState({ isLoading: false });
    }
  };

  handleTargetSelectClick = (ev: any, item: any) => {
    const { handleTargetSelect } = this.props;
    ev.preventDefault();
    handleTargetSelect({
      targetId: item.id,
      targetType: SentinelTargetType.ENERGYPRO,
    });
  };

  render() {
    const { energyPros = [], isLoading } = this.state;
    const { site, selected } = this.props;

    if (isLoading) {
      return <div className={styles.tableLoading}>Loading...</div>;
    }

    return (
      <div>
        <table className={styles.table}>
          <tbody>
            {energyPros.length === 0 ? (
              <tr>
                <td colSpan={4}>
                  <div>This site has no energy pros.</div>
                </td>
              </tr>
            ) : (
              energyPros.map((item: EnergyPro) => (
                <tr
                  key={`rolloutSensorRow${item.id}`}
                  onClick={ev => this.handleTargetSelectClick(ev, item)}
                  className={styles.filterRow}
                >
                  <td style={{ width: '25%' }}>
                    <SensorChip title={item.title} />
                  </td>
                  <td style={{ width: '25%' }}>
                    <ResourcePath
                      suppressLink
                      resourceId={item.id}
                      resourceType={ResourceType.SPACE}
                    />
                  </td>
                  <td className={styles.action} style={{ width: '15%' }}>
                    <Checkbox
                      checked={selected.includes(item.id)}
                      onChange={ev => this.handleTargetSelectClick(ev, item)}
                      id={`checkbox_${site.id}_${item.id}`}
                      size={16}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default StepRolloutEnergyPros;
